var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementRegistRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_10667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8876 7.37073C16.1766 5.1731 20.0434 4.00012 23.999 4.00012C26.6255 4.00012 29.2262 4.51744 31.6527 5.52253C34.0792 6.52763 36.284 8.00082 38.1412 9.85799C39.9983 11.7152 41.4715 13.9199 42.4766 16.3465C43.4817 18.773 43.999 21.3737 43.999 24.0001C43.999 27.9557 42.826 31.8225 40.6284 35.1115C38.4308 38.4005 35.3072 40.964 31.6527 42.4777C27.9982 43.9915 23.9768 44.3875 20.0972 43.6158C16.2176 42.8441 12.6539 40.9393 9.8569 38.1423C7.05985 35.3452 5.15503 31.7815 4.38333 27.9019C3.61162 24.0223 4.00769 20.001 5.52144 16.3465C7.03519 12.6919 9.59864 9.56836 12.8876 7.37073Z",
    fill: "#FF9200"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_369_10667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15.25C22.2694 15.25 20.5777 15.7632 19.1388 16.7246C17.6998 17.6861 16.5783 19.0527 15.9161 20.6515C15.2538 22.2504 15.0805 24.0097 15.4181 25.707C15.7558 27.4044 16.5891 28.9635 17.8128 30.1872C19.0365 31.4109 20.5956 32.2443 22.293 32.5819C23.9903 32.9195 25.7496 32.7462 27.3485 32.0839C28.9473 31.4217 30.3139 30.3002 31.2754 28.8612C32.2368 27.4223 32.75 25.7306 32.75 24C32.75 22.8509 32.5237 21.7131 32.084 20.6515C31.6442 19.5899 30.9997 18.6253 30.1872 17.8128C29.3747 17.0003 28.4101 16.3558 27.3485 15.9161C26.2869 15.4763 25.1491 15.25 24 15.25ZM27.5 24.875H24C23.7679 24.875 23.5454 24.7828 23.3813 24.6187C23.2172 24.4546 23.125 24.2321 23.125 24V20.5C23.125 20.2679 23.2172 20.0454 23.3813 19.8813C23.5454 19.7172 23.7679 19.625 24 19.625C24.2321 19.625 24.4546 19.7172 24.6187 19.8813C24.7828 20.0454 24.875 20.2679 24.875 20.5V23.125H27.5C27.7321 23.125 27.9546 23.2172 28.1187 23.3813C28.2828 23.5454 28.375 23.7679 28.375 24C28.375 24.2321 28.2828 24.4546 28.1187 24.6187C27.9546 24.7828 27.7321 24.875 27.5 24.875Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_10667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_369_10667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(13.5 13.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementRegistRequest);
export default __webpack_public_path__ + "static/media/icon_settlement_regist_request.10978be4ccf824226dba6e34f27cdb53.svg";
export { ForwardRef as ReactComponent };